
export const globalExternalStylesheets = [
  "https://use.typekit.net/jvr1gjm.css",
  "https://use.typekit.net/tqv5rhd.css"
];
